export const IconDesktop = require('react-icons/lib/md/desktop-windows');
export const IconLineChart = require('react-icons/lib/fa/line-chart');
export const IconPieChart = require('react-icons/lib/fa/pie-chart');
export const IconBarChart = require('react-icons/lib/fa/bar-chart');
export const IconPaperPlane = require('react-icons/lib/io/ios-paperplane');
export const IconFacebookSquare = require('react-icons/lib/fa/facebook-square');
export const IconTwitterSquare = require('react-icons/lib/fa/twitter-square');
export const IconLinkedinSquare = require('react-icons/lib/fa/linkedin-square');
export const IconAndroid = require('react-icons/lib/md/android');
export const IconApple = require('react-icons/lib/io/social-apple');
export const IconBotUser = require('react-icons/lib/md/record-voice-over');
export const IconGroup = require('react-icons/lib/fa/group');
export const IconUser = require('react-icons/lib/fa/user');
export const IconStar = require('react-icons/lib/fa/star-o');
export const IconTable = require('react-icons/lib/fa/th');
export const IconSetting = require('react-icons/lib/md/settings');
export const IconMessage = require('react-icons/lib/md/insert-comment');
export const IconPhone = require('react-icons/lib/fa/phone');
export const IconEmail = require('react-icons/lib/md/email');
export const IconDashboardMeter = require('react-icons/lib/io/ios-speedometer');
export const IconHistory = require('react-icons/lib/md/history');
export const IconConversation = require('react-icons/lib/fa/wechat');
export const IconBot = require('react-icons/lib/go/hubot');
export const IconRepeat = require('react-icons/lib/md/repeat');
export const IconArrowDown = require('react-icons/lib/md/arrow-downward');
export const IconSession = require('react-icons/lib/io/log-in');
export const IconLock = require('react-icons/lib/md/lock');
export const IconAdd = require('react-icons/lib/md/add-circle');
export const IconEdit = require('react-icons/lib/md/edit');
export const IconDelete = require('react-icons/lib/md/delete');
export const IconClose = require('react-icons/lib/md/close');
export const IconRight = require('react-icons/lib/md/chevron-right');
export const IconDown = require('react-icons/lib/md/expand-more');
export const IconMenuBar = require('react-icons/lib/md/menu');
export const IconMenuDot = require('react-icons/lib/md/more-vert');
export const IconSuccess = require('react-icons/lib/io/android-checkmark-circle');
export const IconCrossCircle = require('react-icons/lib/md/highlight-off');
export const IconConsole = require('react-icons/lib/md/donut-large')



// WEBPACK FOOTER //
// ./src/data/assets/icons/index.js